export default "__VITE_ASSET__CztlQDh0__"